import { render, staticRenderFns } from "./PercentIcon.vue?vue&type=template&id=34113ed3"
import script from "./PercentIcon.vue?vue&type=script&lang=js"
export * from "./PercentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports